import { AuthRoute } from "src/modules/auth/auth.routes";
import { CommercialRoute } from "src/modules/commercial/commercial.routes";
import { ConfigurationRoute } from "src/modules/configurations/configuration.routes";
import { OthersRoute } from "src/modules/others/others.routes";
import { GateEnteryRoute } from "src/modules/gate-entery/gate-entry.routes";
import { ManagementRoute } from "src/modules/management/management.routes";
import { ReportsRoute } from "src/modules/reports/report.routes";
import { UnauthorizedRoute } from "src/modules/unauthorized/unauthorized.routes";
import { VehicleManagementRoute } from "src/modules/vehicle-management/vehicle-management.routes";
import { InsightsRoute } from "../modules/insights/insight.routes";
import { WereHouseRoute } from "./../modules/were-house/were-house.routes";
import { YardRoute } from "./../modules/yard-management/yard.routes";
import { CameraRoute } from "src/modules/camera/camera.routes";
import { ChangePasswordRoute } from "src/modules/change-password/change-password.routes";
import { NodGateEnteryRoute } from "src/modules/nod-gate-entery/gate-entry.routes";
import { NodConfigurationRoute } from "src/modules/nod-configurations/configuration.routes";
import { ManagementRoute as NodManagementRoute } from "src/modules/nod-management/management.routes";
import { VehicleManagementRoute as NodVehicleManagementRoute } from "src/modules/nod-vehicle-management/vehicle-management.routes";
import { NodInsightsRoute } from "src/modules/nod-insights/nod-insight.routes";
import { HeadQuarterRoute } from "src/modules/head-quarter/head-quarter.routes";
import { NodWereHouseRoute } from "src/modules/nod-were-house/nod-were-house.routes";
import { YardRoute as NodYardManagementRoute } from "src/modules/nod-yard-management/yard.routes";
import { SettingsRoute } from "src/modules/settings/setting.routes";
import { NodCommercialRoute } from "src/modules/nod-commercial/nod-commercial.routes";

export const ROUTES = [
  AuthRoute,
  InsightsRoute,
  GateEnteryRoute,
  VehicleManagementRoute,
  YardRoute,
  ConfigurationRoute,
  ManagementRoute,
  WereHouseRoute,
  CommercialRoute,
  OthersRoute,
  ReportsRoute,
  UnauthorizedRoute,
  CameraRoute,
  ChangePasswordRoute,
  NodGateEnteryRoute,
  NodConfigurationRoute,
  NodManagementRoute,
  NodVehicleManagementRoute,
  NodInsightsRoute,
  HeadQuarterRoute,
  NodWereHouseRoute,
  NodYardManagementRoute,
  SettingsRoute,
  NodCommercialRoute,
];
